import { Badge } from "@/components/ui/badge";

const STATUS_STYLES = {
    pending: "bg-amber-100 text-amber-800 border-amber-200",
    in_review: "bg-blue-100 text-blue-800 border-blue-200",
    approved: "bg-emerald-100 text-emerald-800 border-emerald-200",
    completed: "bg-emerald-100 text-emerald-800 border-emerald-200",
    rejected: "bg-red-100 text-red-800 border-red-200",
    active: "bg-emerald-100 text-emerald-800 border-emerald-200",
    inactive: "bg-slate-100 text-slate-700 border-slate-200",
};

const LABELS = {
    pending: "Pending",
    in_review: "In Review",
    approved: "Approved",
    completed: "Completed",
    rejected: "Rejected",
    active: "Active",
    inactive: "Inactive",
};

export default function StatusBadge({ status, label, ...rest }) {
    const cls = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-200";
    return (
        <Badge
            variant="outline"
            className={`${cls} font-medium uppercase text-[10px] tracking-wider`}
            {...rest}
        >
            {label || LABELS[status] || status}
        </Badge>
    );
}
